export default class ApiUrl {
  // // // this is for development
  // public static baseUrl: string = "http://192.168.1.11:8009/api";
  // public static fileBaseUrl: string = "http://192.168.1.11:8009/media/";
  // public static version: string = "0.0.4";

  // this is for production
  public static baseUrl: string = "https://apibeta.ewts.ae/api";
  public static fileBaseUrl: string = "https://apibeta.ewts.ae/media/";
  public static version: string = "0.1.1";
}
